function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var Transaction = require('../../lib/saito/transaction')["default"];
var ModTemplate = require('../../lib/templates/modtemplate');
var PeerService = require('saito-js/lib/peer_service')["default"];

/***
 *  A generic utility for creating stun connections that other modules can use
 *  API is a combination of respondTo and event space
 *
 * Will emit (with publicKey of peer):
 *  'stun-new-peer-connection'
 *
 * 	'stun-connection-connected' --- when you have created the basic stun connection (for media streaming)
 *  'stun-connection-failed'
 *  'stun-data-channel-open'
 *  'stun-data-channel-close'
 *  'stun-update-connection-message'
 *
 *  'stun-track-event'
 *
 * 	Your modules can set a listener for these and process accordingly
 */
var Stun = /*#__PURE__*/function (_ModTemplate) {
  function Stun(app) {
    var _this;
    _classCallCheck(this, Stun);
    _this = _callSuper(this, Stun, [app]);
    _this.app = app;
    _this.name = 'Stun';
    _this.slug = 'stun';
    _this.description = 'P2P Connection Module';
    _this.categories = 'Utilities Communications';
    _this["class"] = 'utility';
    _this.status = 'prod';
    _this.servers = [{
      urls: 'turn:stun-sf.saito.io:3478',
      username: 'guest',
      credential: 'somepassword'
    }, {
      urls: 'turn:stun-sg.saito.io:3478',
      username: 'guest',
      credential: 'somepassword'
    }, {
      urls: 'turn:stun-de.saito.io:3478',
      username: 'guest',
      credential: 'somepassword'
    }

    // Firefox gives a warning if you provide more than two servers and
    // throws an error if you use 5 or more.
    // is it redundant to have both turn and stun on the same server, since
    //
    // " TURN (Traversal Using Relay NAT) is the more advanced solution that incorporates
    // the STUN protocols and most commercial WebRTC based services use a TURN server
    // for establishing connections between peers. "

    /*{
      urls: "stun:stun-sf.saito.io:3478",
    },
    {
      urls: "stun:stun-sg.saito.io:3478",
    },
    {
      urls: "stun:stun-de.saito.io:3478",
    },*/];
    _this.peers = new Map();
    _this.noloop = []; // array of failed/timedout peer publickeys, so we don't repeat ad infinitum

    // app.connection.on("stun-data-channel-open", async (publicKey) => {

    // 	 await this.app.network.addStunPeer(publicKey, this.peers.get(publicKey))

    // });

    app.connection.on('stun-connection-connected', function (publicKey) {
      //await this.app.network.addStunPeer(publicKey, this.peers.get(publicKey))
      siteMessage("Opened stun connection with ".concat(app.keychain.returnUsername(publicKey)), 2000);
    });
    app.connection.on('stun-data-channel-close', function (publicKey) {
      siteMessage("Closed stun connection with ".concat(app.keychain.returnUsername(publicKey)), 2000);
    });
    app.connection.on('stun-connection-failed', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(peerId, callback) {
        var c;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return sconfirm("STUN: connection failed -- ".concat(app.keychain.returnUsername(peerId), ". Keep trying?"));
            case 1:
              c = _context.v;
              if (c) {
                _this.createPeerConnection(peerId, callback);
              } else {
                // Notify the module UI that we have given up connecting
                app.connection.emit('stun-connection-close', peerId);
                console.error('STUN: failed connections-- ', _this.noloop);
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    app.connection.on('stun-connection-timeout', /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(peerId, delay, callback) {
        var peerConnection, c;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              console.warn('STUN: connection timeout', peerId);
              peerConnection = _this.peers.get(peerId);
              c = null;
              if (peerConnection) {
                // Quietly give up — do not prompt the user on timeout.
                // c = await sconfirm(
                //   `STUN: connection timed out -- ${app.keychain.returnUsername(peerId)} might not be online. Keep waiting?`
                // );
              }
              if (c) {
                _this.createPeerConnection(peerId, callback);
                delay *= 2;
                peerConnection.timer = setTimeout(function () {
                  if (!_this.hasConnectionWithPeer(peerId)) {
                    app.connection.emit('stun-connection-timeout', peerId, delay, callback);
                  } else {
                    console.warn('Stun: peerConnection timer expired but we have a connection...');
                  }
                }, delay);
              } else {
                // Notify the module UI that we have given up connecting
                app.connection.emit('stun-connection-close', peerId);
                console.error('STUN: failed connections-- ', _this.noloop);
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x3, _x4, _x5) {
        return _ref2.apply(this, arguments);
      };
    }());
    return _this;
  }
  _inherits(Stun, _ModTemplate);
  return _createClass(Stun, [{
    key: "respondTo",
    value: function respondTo(type, obj) {
      var _this2 = this;
      var stun_self = this;
      if (type === 'peer-manager') {
        return {
          hasConnection: function hasConnection(peerId) {
            var any_status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            if (any_status) {
              if (_this2.peers.has(peerId)) {
                var pc = _this2.peers.get(peerId);
                if (pc.connectionState == 'failed' || pc.connectionState == 'disconnected') {
                  return false;
                }
                return true;
              }
            } else {
              return _this2.hasConnection(peerId);
            }
            return false;
          },
          sendTransaction: function sendTransaction(peerId, tx) {
            _this2.sendTransaction(peerId, tx);
          },
          // For the API, it isn't enough for one party to create a peer connection, so if you don't
          // provide a callback, it uses the sendJoinTransaction to message your peer and have them
          // create a peer connection on their end, it is akin to texting your friend to say call me.
          // This is good for most data channel set ups, but if you need more control over who messages
          // who when you can get around this by setting the callback deliberately to false. (i.e. my friend
          // has texted me and it is on me to call them)
          createPeerConnection: function createPeerConnection(peerId) {
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            //
            // send ready message to peer, so if they want to create the channel, we are receptive
            //
            if (callback == null) {
              console.debug('STUN API: Create dummy callback for joinTransaction');
              callback = function callback(peerId) {
                _this2.sendJoinTransaction(peerId);
              };
            } else if (!callback) {
              console.debug('STUN API: We are intentionally not setting a callback in the stun connection API');
            }
            if (Array.isArray(peerId)) {
              peerId.forEach(function (peer) {
                return _this2.createPeerConnection(peer, callback);
              });
            } else {
              _this2.createPeerConnection(peerId, callback);
            }
          },
          removePeerConnection: function removePeerConnection(peerId) {
            _this2.removePeerConnection(peerId);
          },
          peers: this.peers
        };
      }

      // Temporarily disabled — Upgrade / Downgrade Connection user-menu entries.
      // if (type === 'user-menu') {
      //   if (!obj?.publicKey || obj.publicKey == this.publicKey) {
      //     return null;
      //   }
      //
      //   if (!this.hasConnectionWithPeer(obj.publicKey)) {
      //     return {
      //       text: 'Upgrade Connection',
      //       icon: 'fa-solid fa-bolt-lightning',
      //       callback: function (app, public_key) {
      //         stun_self.createPeerConnection(public_key, () => {
      //           stun_self.sendJoinTransaction(public_key);
      //         });
      //       }
      //     };
      //   } else {
      //     return {
      //       text: 'Downgrade Connection',
      //       icon: 'fa-solid fa-shield-cat',
      //       callback: async function (app, public_key) {
      //         let newtx = await app.wallet.createUnsignedTransactionWithDefaultFee(public_key);
      //
      //         newtx.msg = {
      //           module: 'Stun',
      //           request: 'peer-left'
      //         };
      //
      //         await newtx.sign();
      //
      //         app.connection.emit('relay-transaction', newtx);
      //
      //         setTimeout(() => {
      //           stun_self.removePeerConnection(public_key);
      //         }, 500);
      //       }
      //     };
      //   }
      // }

      return null;
    }

    // Dummy functions for testing stun-data-channel upgrade to PEER object
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (this.app.BROWSER == 1) {
        services.push(new PeerService(null, 'stun-test'));
      }
      return services;
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, peer) {
        var service,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              service = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
              if (service.service === 'stun-test') {
                if (this.hasConnection(peer.publicKey)) {
                  console.info('STUN PEER UPGRADE SUCCESS!!!! ' + peer.publicKey);
                  app.keychain.addKey(peer.publicKey, {
                    lastUpdate: Date.now()
                  });
                }
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function onPeerServiceUp(_x6, _x7) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "hasConnection",
    value: function hasConnection(peerId) {
      if (Array.isArray(peerId)) {
        if (peerId.length == 0) {
          return false;
        }
        var answer = true;
        var _iterator = _createForOfIteratorHelper(peerId),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var peer = _step.value;
            if (!this.hasConnectionWithPeer(peer)) {
              return false;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return answer;
      } else {
        return this.hasConnectionWithPeer(peerId);
      }
    }
  }, {
    key: "hasConnectionWithPeer",
    value: function hasConnectionWithPeer(peerId) {
      var peerConnection = this.peers.get(peerId);
      if (peerConnection) {
        if (peerConnection !== null && peerConnection !== void 0 && peerConnection.dc) {
          if (peerConnection.connectionState == 'connected') {
            if (peerConnection.dc.readyState == 'open') {
              return true;
            }
          }
        }
      }
      return false;
    }
  }, {
    key: "sendTransaction",
    value: function sendTransaction(peerId, tx) {
      if (!this.hasConnectionWithPeer(peerId)) {
        console.warn('Stun: cannot send transaction over stun');
        return;
      }
      try {
        var peerConnection = this.peers.get(peerId);
        peerConnection.dc.send(tx.serialize_to_web(this.app));
      } catch (err) {
        console.error('Stun sendTransaction ERROR:', err);
      }
    }
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(blk, tx, conf) {
        var _this3 = this;
        var message, peerId, peerConnection;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(tx == null)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              message = tx.returnMessage();
              if (!(Number(conf) == 0)) {
                _context4.n = 4;
                break;
              }
              if (!(message.module === 'Stun')) {
                _context4.n = 4;
                break;
              }
              if (!(this.app.BROWSER === 1)) {
                _context4.n = 4;
                break;
              }
              if (!(tx.isTo(this.publicKey) && !tx.isFrom(this.publicKey))) {
                _context4.n = 3;
                break;
              }
              if (!this.hasSeenTransaction(tx, blk)) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              _context4.n = 3;
              return this.handleSignalingMessage(tx.from[0].publicKey, message.request, message);
            case 3:
              if (message.request == 'peer-joined') {
                if (tx.isFrom(this.publicKey)) {
                  console.log('STUN: onConfirmation', message);
                  peerId = tx.to[0].publicKey;
                  peerConnection = this.peers.get(peerId);
                  if (peerConnection) {
                    if (peerConnection.connectionState !== 'connected') {
                      console.log('STUN: setting connection timer with on chain confirmation that my peer join transaction was sent');
                      peerConnection.timer = setTimeout(function () {
                        if (!_this3.hasConnectionWithPeer(peerId)) {
                          _this3.app.connection.emit('stun-connection-timeout', peerId, 5000, _this3.callback);
                        } else {
                          console.warn('Stun: peerConnection timer expired but we have a connection...');
                        }
                      }, 10000);
                    }
                  }
                }
              }
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onConfirmation(_x8, _x9, _x0) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app) {
        var tx,
          peer,
          mycallback,
          txmsg,
          _args5 = arguments;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              tx = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : null;
              peer = _args5.length > 2 ? _args5[2] : undefined;
              mycallback = _args5.length > 3 ? _args5[3] : undefined;
              if (!(tx == null)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              txmsg = tx.returnMessage();
              if (!(txmsg.module !== this.name)) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2);
            case 2:
              if (!(this.app.BROWSER === 1)) {
                _context5.n = 4;
                break;
              }
              if (!(tx.isTo(this.publicKey) && !tx.isFrom(this.publicKey))) {
                _context5.n = 4;
                break;
              }
              if (!this.hasSeenTransaction(tx)) {
                _context5.n = 3;
                break;
              }
              return _context5.a(2);
            case 3:
              _context5.n = 4;
              return this.handleSignalingMessage(tx.from[0].publicKey, txmsg.request, txmsg);
            case 4:
              return _context5.a(2, _superPropGet(Stun, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee5, this);
      }));
      function handlePeerTransaction(_x1) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }() // Observational local event for call diagnostics; no wire payloads are retained.
  }, {
    key: "diagnostic",
    value: function diagnostic(peer, message) {
      var _this$app;
      (_this$app = this.app) === null || _this$app === void 0 || _this$app.connection.emit('stun-diagnostic', peer, message);
    }
  }, {
    key: "handleSignalingMessage",
    value: function () {
      var _handleSignalingMessage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(sender, request, data) {
        var _data$description;
        var peerConnection, description, readyForOffer, offerCollision, candidates, _iterator2, _step2, candidate, _peerConnection$pendi, _t, _t2;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              this.diagnostic(sender, "Received ".concat(request).concat((_data$description = data.description) !== null && _data$description !== void 0 && _data$description.type ? " (".concat(data.description.type, ")") : ''));
              //
              // Stun metadata messages
              //
              if (!(request == 'peer-joined')) {
                _context6.n = 1;
                break;
              }
              console.debug('Stun: Peer joined (requested a connection)');
              this.createPeerConnection(sender);
              return _context6.a(2);
            case 1:
              if (!(request == 'peer-left')) {
                _context6.n = 2;
                break;
              }
              console.debug('Stun: Peer left (close the connection)');
              this.removePeerConnection(sender);
              return _context6.a(2);
            case 2:
              if (!(request == 'peer-kicked')) {
                _context6.n = 3;
                break;
              }
              console.debug('Stun: Peer kicked out (close the connection)');
              this.removePeerConnection(sender);
              return _context6.a(2);
            case 3:
              peerConnection = this.peers.get(sender);
              if (peerConnection) {
                _context6.n = 4;
                break;
              }
              this.diagnostic(sender, 'Signal ignored: no peer connection');
              console.warn("Stun: Receiving signalling messages for a non-peer connection [".concat(sender, "], peers: "), this.peers.keys());
              return _context6.a(2);
            case 4:
              if (!(request == 'peer-description')) {
                _context6.n = 19;
                break;
              }
              description = data.description;
              _context6.p = 5;
              readyForOffer = !(peerConnection !== null && peerConnection !== void 0 && peerConnection.makingOffer) && (peerConnection.signalingState == 'stable' || (peerConnection === null || peerConnection === void 0 ? void 0 : peerConnection.answerPending));
              offerCollision = description.type === 'offer' && !readyForOffer;
              peerConnection.ignoreOffer = offerCollision && (peerConnection === null || peerConnection === void 0 ? void 0 : peerConnection.rude);
              if (!peerConnection.ignoreOffer) {
                _context6.n = 6;
                break;
              }
              this.diagnostic(sender, 'Ignored colliding offer (impolite peer)');
              console.debug('STUN: Impolite peer ignores offer collision');
              return _context6.a(2);
            case 6:
              if (description.type === 'offer') {
                // An incoming offer can satisfy the deferred negotiation. The browser
                // will emit negotiationneeded again if local changes remain after the answer.
                clearTimeout(peerConnection.offerTimer);
                peerConnection.offerTimer = null;
              }
              peerConnection.answerPending = description.type == 'answer';
              _context6.n = 7;
              return peerConnection.setRemoteDescription(description);
            case 7:
              this.diagnostic(sender, "Applied remote ".concat(description.type));
              peerConnection.answerPending = false;

              // Relay delivery can put ICE candidates ahead of their SDP. WebRTC
              // rejects them until a remote description exists, so apply them now.
              candidates = peerConnection.pendingCandidates || [];
              delete peerConnection.pendingCandidates;
              _iterator2 = _createForOfIteratorHelper(candidates);
              _context6.p = 8;
              _iterator2.s();
            case 9:
              if ((_step2 = _iterator2.n()).done) {
                _context6.n = 11;
                break;
              }
              candidate = _step2.value;
              _context6.n = 10;
              return this.addIceCandidate(sender, peerConnection, candidate);
            case 10:
              _context6.n = 9;
              break;
            case 11:
              _context6.n = 13;
              break;
            case 12:
              _context6.p = 12;
              _t = _context6.v;
              _iterator2.e(_t);
            case 13:
              _context6.p = 13;
              _iterator2.f();
              return _context6.f(13);
            case 14:
              if (!(description.type === 'offer')) {
                _context6.n = 16;
                break;
              }
              _context6.n = 15;
              return peerConnection.setLocalDescription();
            case 15:
              this.sendPeerDescriptionTransaction(sender, peerConnection.localDescription);
            case 16:
              this.peers.set(sender, peerConnection);
              _context6.n = 18;
              break;
            case 17:
              _context6.p = 17;
              _t2 = _context6.v;
              this.diagnostic(sender, "Apply description failed: ".concat(_t2.name));
              console.error('STUN: failure in peer-offer --- ', _t2);
              console.debug('STUN: impolite? ', peerConnection.rude, 'signalingState: ', peerConnection.signalingState, 'answerPending: ', peerConnection.answerPending, 'description type: ', description.type);
            case 18:
              return _context6.a(2);
            case 19:
              if (!(request === 'peer-candidate')) {
                _context6.n = 22;
                break;
              }
              if (peerConnection.remoteDescription) {
                _context6.n = 20;
                break;
              }
              (_peerConnection$pendi = peerConnection.pendingCandidates) !== null && _peerConnection$pendi !== void 0 ? _peerConnection$pendi : peerConnection.pendingCandidates = [];
              peerConnection.pendingCandidates.push(data.iceCandidate);
              this.diagnostic(sender, 'Queued remote ICE candidate until SDP arrives');
              return _context6.a(2);
            case 20:
              _context6.n = 21;
              return this.addIceCandidate(sender, peerConnection, data.iceCandidate);
            case 21:
              return _context6.a(2);
            case 22:
              console.warn('Unknown Stun Peer Transaction!', data);
            case 23:
              return _context6.a(2);
          }
        }, _callee6, this, [[8, 12, 13, 14], [5, 17]]);
      }));
      function handleSignalingMessage(_x10, _x11, _x12) {
        return _handleSignalingMessage.apply(this, arguments);
      }
      return handleSignalingMessage;
    }()
  }, {
    key: "addIceCandidate",
    value: function () {
      var _addIceCandidate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(peerId, peerConnection, candidate) {
        var _t3;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              _context7.n = 1;
              return peerConnection.addIceCandidate(candidate);
            case 1:
              this.diagnostic(peerId, 'Applied remote ICE candidate');
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t3 = _context7.v;
              this.diagnostic(peerId, "ICE candidate rejected: ".concat(_t3.name).concat(peerConnection.ignoreOffer ? ' (ignored offer)' : ''));
              if (!peerConnection.ignoreOffer) {
                console.error('STUN: Error adding remote candidate:', _t3, candidate);
                console.warn(peerId, this.publicKey);
              }
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function addIceCandidate(_x13, _x14, _x15) {
        return _addIceCandidate.apply(this, arguments);
      }
      return addIceCandidate;
    }() //
    // We treat all data channel messages a peer request / peer transaction
    //
  }, {
    key: "handleDataChannelMessage",
    value: function handleDataChannelMessage(data, peerId) {
      var relayed_tx = new Transaction();
      relayed_tx.deserialize_from_web(this.app, data);
      this.app.modules.handlePeerTransaction(relayed_tx);
    }
  }, {
    key: "sendJoinTransaction",
    value: function () {
      var _sendJoinTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(peer) {
        var newtx, _t4;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              this.diagnostic(peer, 'Submitting peer-joined');
              _context8.p = 1;
              _context8.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(peer);
            case 2:
              newtx = _context8.v;
              newtx.msg = {
                module: 'Stun',
                request: 'peer-joined'
              };
              _context8.n = 3;
              return newtx.sign();
            case 3:
              this.app.connection.emit('relay-transaction', newtx);
              this.app.network.propagateTransaction(newtx);
              this.diagnostic(peer, 'Submitted peer-joined to relay / network');
              _context8.n = 5;
              break;
            case 4:
              _context8.p = 4;
              _t4 = _context8.v;
              this.diagnostic(peer, "Failed to submit peer-joined: ".concat(_t4.name));
              throw _t4;
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 4]]);
      }));
      function sendJoinTransaction(_x16) {
        return _sendJoinTransaction.apply(this, arguments);
      }
      return sendJoinTransaction;
    }()
  }, {
    key: "sendPeerDescriptionTransaction",
    value: function () {
      var _sendPeerDescriptionTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(peer, description) {
        var newtx, _t5;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              this.diagnostic(peer, "Submitting SDP (".concat(description.type, ")"));
              _context9.p = 1;
              _context9.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(peer);
            case 2:
              newtx = _context9.v;
              console.info("STUN: sending offer to ".concat(peer, " with peer connection ") + this.peers.get(peer).signalingState, description.type);
              newtx.msg = {
                module: 'Stun',
                request: 'peer-description',
                description: description
              };
              _context9.n = 3;
              return newtx.sign();
            case 3:
              this.app.connection.emit('relay-transaction', newtx);
              this.app.network.propagateTransaction(newtx);
              this.diagnostic(peer, 'Submitted SDP to relay / network');
              _context9.n = 5;
              break;
            case 4:
              _context9.p = 4;
              _t5 = _context9.v;
              this.diagnostic(peer, "Failed to submit SDP: ".concat(_t5.name));
              throw _t5;
            case 5:
              return _context9.a(2);
          }
        }, _callee9, this, [[1, 4]]);
      }));
      function sendPeerDescriptionTransaction(_x17, _x18) {
        return _sendPeerDescriptionTransaction.apply(this, arguments);
      }
      return sendPeerDescriptionTransaction;
    }()
  }, {
    key: "sendIceCandidateTransaction",
    value: function () {
      var _sendIceCandidateTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(peer, candidate) {
        var newtx, _t6;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              this.diagnostic(peer, 'Submitting ICE candidate');
              _context0.p = 1;
              _context0.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(peer);
            case 2:
              newtx = _context0.v;
              newtx.msg = {
                module: 'Stun',
                request: 'peer-candidate',
                iceCandidate: candidate
              };
              _context0.n = 3;
              return newtx.sign();
            case 3:
              this.app.connection.emit('relay-transaction', newtx);
              this.app.network.propagateTransaction(newtx);
              this.diagnostic(peer, 'Submitted ICE candidate to relay / network');
              _context0.n = 5;
              break;
            case 4:
              _context0.p = 4;
              _t6 = _context0.v;
              this.diagnostic(peer, "Failed to submit ICE candidate: ".concat(_t6.name));
              throw _t6;
            case 5:
              return _context0.a(2);
          }
        }, _callee0, this, [[1, 4]]);
      }));
      function sendIceCandidateTransaction(_x19, _x20) {
        return _sendIceCandidateTransaction.apply(this, arguments);
      }
      return sendIceCandidateTransaction;
    }()
  }, {
    key: "restoreConnection",
    value: function restoreConnection(peerId, pathway, callback) {
      var _this4 = this;
      this.diagnostic(peerId, 'Attempting connection recovery');
      this.removePeerConnection(peerId);
      if (!this.noloop.includes(peerId)) {
        if (callback) {
          console.info('Attempt STUN reconnection once');
          setTimeout(function () {
            _this4.createPeerConnection(peerId, callback);
          }, 500);
          this.noloop.push(peerId);
        }
      } else {
        this.diagnostic(peerId, 'Recovery exhausted after two attempts');
        console.warn('STUN reconnection attempt failed after two tries, give up!');
        this.app.connection.emit(pathway, peerId, callback);
        for (var i = 0; i < this.noloop.length; i++) {
          if (this.noloop[i] == peerId) {
            this.noloop.splice(i, 1);
            break;
          }
        }
      }
    }
  }, {
    key: "createPeerConnection",
    value: function createPeerConnection(peerId) {
      var _this5 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.diagnostic(peerId, 'Requested peer connection');
      console.info('STUN/TALK: Create Peer Connection with ' + peerId + " and ".concat(callback ? 'a' : 'no', " callback"), this.noloop);
      if (peerId === this.publicKey) {
        console.warn('STUN/TALK: Attempting to create a peer Connection with myself!');
        console.trace();
        return 0;
      }
      if (this.peers.get(peerId)) {
        var pc = this.peers.get(peerId);
        this.diagnostic(peerId, "Existing connection: ".concat(pc.connectionState));
        console.debug("STUN/TALK: ".concat(peerId, " already in stun peer list"), 'Status: ' + pc.connectionState);
        if (pc.timer) {
          console.debug('STUN/TALK: cancelling a timeout for new connection round...');
          //cancel timer if any activity on connectionstate
          clearTimeout(pc.timer);
          delete this.callback;
          delete pc.timer;
        }

        //If not a solid connection state..., delete and try again
        if (pc.connectionState == 'failed' || pc.connectionState == 'disconnected') {
          console.warn('STUN/TALK: old peer has broken connection, reestablish...');
          this.restoreConnection(peerId, 'stun-connection-failed', callback);
          return;
        }
        if (pc.connectionState == 'new' || pc.connectionState == 'connecting') {
          // Reuse negotiation already in progress, but allow a new call to attach
          // media and notify its peer even if this began as a data-only connection.
          this.app.connection.emit('stun-new-peer-connection', peerId, pc);
          if (callback) callback(peerId);
          return;
        }
        if (callback) {
          console.debug('STUN/TALK: run peerConnection callback', callback);
          callback(peerId);
        }

        //
        // Assuming you are properly connected, simulate that the connection just came through,
        // so the mods listeners can pick up and do their UI things
        //
        // Todo: this is a mess, should streamline events in stun,
        // the UI components are a little too indebted to the old idiosyncratic logic
        //
        this.app.connection.emit('stun-new-peer-connection', peerId, pc);
        if (pc.connectionState === 'connected') {
          this.app.connection.emit('stun-connection-connected', peerId);
        } else {
          this.app.connection.emit('stun-update-connection-message', peerId, pc.connectionState);
        }
        if (this.hasConnection(peerId)) {
          this.app.connection.emit('stun-data-channel-open', peerId);
        }
        return;
      } else {
        var _pc = new RTCPeerConnection({
          iceServers: this.servers
        });

        // use string compare of public keys rather than presence or absence of callback
        // to determine who will be impolite in any pairing because we may be simultnaeously attempting
        // to create connections with callbacks for whatever reason
        if (this.publicKey > peerId) {
          console.debug('STUN: I will be impolite to peer: ', peerId);
          _pc.rude = true;
        }
        this.peers.set(peerId, _pc);
        this.diagnostic(peerId, "Created peer connection (".concat(_pc.rude ? 'impolite' : 'polite', ")"));
        this.app.connection.emit('stun-new-peer-connection', peerId, _pc);
      }
      var peerConnection = this.peers.get(peerId);

      // Handle ICE candidates
      peerConnection.onicecandidate = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(event) {
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.n) {
              case 0:
                if (!event.candidate) {
                  _context1.n = 1;
                  break;
                }
                console.debug('STUN: receiving ice candidate for ', peerId /*, event.candidate*/);
                _context1.n = 1;
                return _this5.sendIceCandidateTransaction(peerId, event.candidate);
              case 1:
                return _context1.a(2);
            }
          }, _callee1);
        }));
        return function (_x21) {
          return _ref3.apply(this, arguments);
        };
      }();

      //Receive Remote media
      peerConnection.addEventListener('track', function (event) {
        _this5.diagnostic(peerId, "Received ".concat(event.track.kind, " track (").concat(event.track.readyState, ")"));
        var _loop = function _loop() {
          var state = _arr[_i];
          event.track.addEventListener(state, function () {
            return _this5.diagnostic(peerId, "".concat(event.track.kind, " track: ").concat(state));
          });
        };
        for (var _i = 0, _arr = ['mute', 'unmute', 'ended']; _i < _arr.length; _i++) {
          _loop();
        }
        console.debug('STUN: new track', peerId, event);
        _this5.app.connection.emit('stun-track-event', peerId, event);
      });
      peerConnection.onconnectionstatechange = function () {
        _this5.diagnostic(peerId, "Connection: ".concat(peerConnection.connectionState));
        console.info("STUN: ".concat(peerId, " connectionstatechange -- ") + peerConnection.connectionState);

        //cancel timer if any activity on connectionstate
        clearTimeout(peerConnection.timer);
        delete peerConnection.timer;
        delete _this5.callback;
        if (peerConnection.connectionState === 'failed' || peerConnection.connectionState === 'disconnected') {
          console.debug('STUN: set reconnection timer...');
          var timerAmt = callback ? 9000 : 5000;
          _this5.diagnostic(peerId, "Waiting ".concat(timerAmt / 1000, "s for connection recovery"));
          peerConnection.timer = setTimeout(function () {
            if (peerConnection.connectionState === 'failed' || peerConnection.connectionState === 'disconnected') {
              _this5.diagnostic(peerId, 'Recovery wait expired; connection still failed/disconnected');
              siteMessage("Stun connection failed with ".concat(peerId));
              console.debug("STUN: connection not restored after ".concat(timerAmt / 1000, " seconds..."));
              //this.restoreConnection(peerId, 'stun-connection-failed', callback);
            } else {
              console.debug("STUN: connection okay ".concat(peerConnection.connectionState, " after timer, don't do anything"));
            }
          }, timerAmt);
        }
        if (peerConnection.connectionState === 'connected') {
          _this5.app.connection.emit('stun-connection-connected', peerId);
        }
        _this5.app.connection.emit('stun-update-connection-message', peerId, peerConnection.connectionState);
      };
      peerConnection.oniceconnectionstatechange = function () {
        _this5.diagnostic(peerId, "ICE: ".concat(peerConnection.iceConnectionState));
        if (peerConnection.iceConnectionState === 'failed') {
          _this5.diagnostic(peerId, 'Attempting ICE restart');
          peerConnection.restartIce();
        }
      };
      peerConnection.onicegatheringstatechange = function () {
        _this5.diagnostic(peerId, "ICE gathering: ".concat(peerConnection.iceGatheringState));
      };
      peerConnection.onsignalingstatechange = function () {
        _this5.diagnostic(peerId, "Signaling: ".concat(peerConnection.signalingState));
      };
      peerConnection.onicecandidateerror = function (event) {
        _this5.diagnostic(peerId, "ICE server error: ".concat(event.errorCode));
      };
      var dc = peerConnection.createDataChannel('data-channel', {
        negotiated: true,
        id: 42
      });
      peerConnection.dc = dc;
      dc.onmessage = function (event) {
        _this5.handleDataChannelMessage(event.data, peerId);
      };
      dc.onopen = function (event) {
        console.info('STUN: Data channel is open');
        _this5.app.connection.emit('stun-data-channel-open', peerId);
      };
      dc.onclose = function (event) {
        console.info('STUN: Data channel is closed with ' + peerId);
        _this5.app.connection.emit('stun-data-channel-close', peerId);
      };

      //
      // Both peers may negotiate (including screen sharing after connection). During
      // initial ICE setup, let the lower public key offer first to reduce collisions
      // and rollback while gathering candidates. The other side still has a bounded
      // fallback when it is the only peer that needs to negotiate.
      //
      var negotiate = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
          var _t7;
          return _regenerator().w(function (_context10) {
            while (1) switch (_context10.p = _context10.n) {
              case 0:
                peerConnection.offerTimer = null;
                if (!(_this5.peers.get(peerId) !== peerConnection || peerConnection.signalingState !== 'stable' || peerConnection.makingOffer)) {
                  _context10.n = 1;
                  break;
                }
                return _context10.a(2);
              case 1:
                _context10.p = 1;
                if (!(peerConnection !== null && peerConnection !== void 0 && peerConnection.negotiation_counter)) {
                  peerConnection.negotiation_counter = 0;
                }
                console.log('STUN: Negotation needed, ', peerConnection.negotiation_counter);
                if (!(peerConnection.negotiation_counter > 10)) {
                  _context10.n = 2;
                  break;
                }
                console.warn("STUN: Negotation needed, but going to cool off instead");
                _this5.diagnostic(peerId, 'Negotiation throttled for 12s');
                peerConnection.negotiation_timeout = setTimeout(function () {
                  peerConnection.negotiation_counter = 0;
                }, 12000);
                return _context10.a(2);
              case 2:
                peerConnection.negotiation_counter++;
                peerConnection.makingOffer = true;
                if (peerConnection !== null && peerConnection !== void 0 && peerConnection.negotiation_timeout) {
                  clearTimeout(peerConnection.negotiation_timeout);
                }
                _context10.n = 3;
                return peerConnection.setLocalDescription();
              case 3:
                if (!(_this5.peers.get(peerId) !== peerConnection || peerConnection.signalingState === 'closed')) {
                  _context10.n = 4;
                  break;
                }
                return _context10.a(2);
              case 4:
                _context10.n = 5;
                return _this5.sendPeerDescriptionTransaction(peerId, peerConnection.localDescription);
              case 5:
                _context10.n = 7;
                break;
              case 6:
                _context10.p = 6;
                _t7 = _context10.v;
                _this5.diagnostic(peerId, "Negotiation failed: ".concat(_t7.name));
                console.error('STUN offer ERROR:', _t7);
              case 7:
                _context10.p = 7;
                peerConnection.makingOffer = false;
                return _context10.f(7);
              case 8:
                return _context10.a(2);
            }
          }, _callee10, null, [[1, 6, 7, 8]]);
        }));
        return function negotiate() {
          return _ref4.apply(this, arguments);
        };
      }();
      peerConnection.onnegotiationneeded = function () {
        _this5.diagnostic(peerId, 'Negotiation needed');
        if (_this5.peers.get(peerId) !== peerConnection || peerConnection.signalingState === 'closed') return;
        if (peerConnection.rude && peerConnection.iceConnectionState === 'new') {
          // Coalesce data-channel creation and media attachment without extending
          // the deadline every time another track is added.
          if (peerConnection.offerTimer != null) return;
          _this5.diagnostic(peerId, 'Deferring initial offer for 1500ms');
          peerConnection.offerTimer = setTimeout(function () {
            return void negotiate();
          }, 1500);
          return;
        }
        clearTimeout(peerConnection.offerTimer);
        return negotiate();
      };
      if (callback) {
        this.callback = callback;
        callback(peerId);
      }
    }

    //This can get double processed by PeerTransaction and onConfirmation
    //So need safety checks
  }, {
    key: "removePeerConnection",
    value: function removePeerConnection(peerId) {
      var peerConnection = this.peers.get(peerId);
      if (peerConnection) {
        console.info('Stun remove peer connection! ' + peerConnection.connectionState);
        this.diagnostic(peerId, 'Closing peer connection');
        clearTimeout(peerConnection.offerTimer);
        clearTimeout(peerConnection.negotiation_timeout);
        clearTimeout(peerConnection.timer);
        peerConnection.close();
        this.peers["delete"](peerId);
      }
    }
  }]);
}(ModTemplate);
module.exports = Stun;